import { DashboardKPIs } from '../../../types/requests';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const getDashboardKpis = (
  constructGet: ConstructGet,
): Promise<NonPaginatedResponse<DashboardKPIs> | undefined> =>
  constructGet<NonPaginatedResponse<DashboardKPIs>>(
    `${PLUGIN_BASE_PATH}/kpi-dashboard-data`,
    {},
  );
